// @flow

import ApiConstants from '../constants/ApiConstants';
import ApiObject from './ApiObject';

import DateUtils from '../utils/DateUtils';
import Moment from '../utils/Types';

export default class Payout extends ApiObject {

  static Status = {
    CREATED: 'CREATED',
    FAILED: 'FAILED',
    SUCCEEDED: 'SUCCEEDED'
  }

  payOutId: string = '';

  // deprecated.
  amount: number = 0;

  // deprecated see creationDate
  date: number = 0;

  status: string = '';

  restId: string;

  /**
   * the VAT percent used to calculate the feesFixed and feesVariable from the restaurant's values which are excluding taxes
   */
  vatPercent: number;

  /**
   * the VAT percent used to calculate the feesFixed and feesVariable from the restaurant's values which are excluding taxes.
   * Rounded.
   */
  vatAmount: number;

  /**
   * the fixed unit price (per payin)
   */
  feesFixedPerPayin: number;

  /**
   * the fixed amount of fees taken on the total amount to transfer to the restaurant, excludng vat
   */
  feesFixedAmountExcludingVat: number;

  /**
   * the variable amount of fees taken on the total amount to transfer to the restaurant, includng vat
   */
  feesVariablePercent: number;

  /**
   * the variable amount of fees taken on the total amount to transfer to the restaurant, includng vat
   */
  feesVariableAmountExcludingVat: number;

  /**
   * total sum of user payments to the restaurant
   */
  grossAmount: number;

  /**
   * amount transfered to the restaurant's bank account, equals to amountIncludingFees - feesFixed - feesVariable
   */
  netAmount: number;

  creationDate: ?Moment = null;

  /**
   * Date of the first payment concerned by this payout
   */
  dateOfFirstPayment: ?Moment = null;

  /**
   * Date of the last payment concerned by this payout
   */
  dateOfLastPayment: ?Moment = null;

  status: string;

  reference: string;

  //
  //
  //

  postJsonAssignation(data: Object) {
    this.creationDate = DateUtils.fromMsTimestamp(data.creationDate);
    this.dateOfFirstPayment = DateUtils.fromMsTimestamp(data.dateOfFirstPayment);
    this.dateOfLastPayment = DateUtils.fromMsTimestamp(data.dateOfLastPayment);
  }

  getFormattedDate(format: string = 'DD/MM/Y'): string {
    return this.creationDate.format(format);
  }

  getFormattedStatus(): string {
    switch (this.status) {
      case Payout.Status.CREATED:
        return 'Crée';
      case Payout.Status.FAILED:
        return 'Erreur'
      case Payout.Status.SUCCEEDED:
        return 'Finalisée';
      default:
        return '';
    }
  }

  getCommissionExcludingTax(): number {
    return this.feesFixedAmountExcludingVat + this.feesVariableAmountExcludingVat
  }

  getCommissionWithTax(): number {
    return this.feesFixedAmountExcludingVat + this.feesVariableAmountExcludingVat + this.vatAmount;
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/Payout.js